/**
 * Client helper for place-autocomplete suggestions via our server API.
 *
 * Proxies requests to hide the private Maps API key from client JavaScript,
 * and enables centralized rate limiting, logging, and error handling.
 */
import type { PlaceSuggestion } from '~/common/types/search';

/**
 * Fetch place autocomplete suggestions from the server API.
 * @param input - The partial address input string.
 * @returns A list of place suggestions with id and description.
 */
export const getSuggestions = async (input: string): Promise<PlaceSuggestion[]> => {
  if (!input) {
    return [];
  }

  try {
    const response = await fetch(`/api/location/suggestions?input=${encodeURIComponent(input)}`);
    if (!response.ok) {
      console.error(`Failed to fetch place suggestions: ${response.statusText}`);
      return [];
    }
    const { suggestions } = (await response.json()) as {
      suggestions: PlaceSuggestion[];
    };
    return suggestions;
  } catch (error) {
    console.error('Error fetching place suggestions:', error);
    return [];
  }
};
